import React from 'react'

import { Context } from 'components/ViewportProvider'

const useMobile = () => {
	return React.useContext(Context)
}

export default useMobile